<template>
  <div class="row justify-between">
    <div class="col-xs-12 col-sm-12 col-lg-6 col-xl-6">
      <div class="form-wrapper">
        <div
          :id="formId"
          @hileadzz_form_loaded="disableForm"
        />
        <i>{{ $t('ui.external_form.preview_page.forms_cannot_be_submitted') }}</i>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-lg-5 col-xl-5">
      <div class="preview-right-box">
        <h3 class="preview-title is-margin-bottom-0">
          {{ $t('ui.external_form.preview_page.title') }}
        </h3>

        <h4 class="is-margin-bottom-0">
          {{ $t('ui.external_form.preview_page.head_section_title') }}
        </h4>
        <p class="preview-paragraph">
          {{ $t('ui.external_form.preview_page.head_paragraph') }}
        </p>
        <pre><code class="preview-code" v-html="headCode"></code></pre>

        <h4 class="is-margin-bottom-0">
          {{ $t('ui.external_form.preview_page.html_section_title') }}
        </h4>
        <p class="preview-paragraph">
          {{ $t('ui.external_form.preview_page.html_paragraph') }}
        </p>
        <pre><code class="preview-code" v-html="htmlCode"></code></pre>

        <h4 class="is-margin-bottom-0">
          {{ $t('ui.external_form.preview_page.script_section_title') }}
        </h4>
        <p class="preview-paragraph">
          {{ $t('ui.external_form.preview_page.script_paragraph') }}
        </p>
        <pre><code class="preview-code" v-html="scriptCode"></code></pre>
      </div>
    </div>
  </div>
</template>
<script>
import { EventBus } from '@/EventBus.js'
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      formId: "hileadzz-form-preview"
    }
  },
  computed: {
    slug() {
      return this.item.slug
    },
    structure() {
      if(this.item) {
        return this.item.unpublished_structure
      }
    },
    hileadzzPublicFormUrl() {
      return this.$store.getters.getHileadzzPublicFormUrl
    },
    headCode() {
      let code = '&lt;head&gt;<br>'
      code    += '  &lt;script src="http://forms.fanomena.io/js/fanomena_form-min.js"&gt;&lt;/script&gt;<br>'
      code    += '&lt;/head&gt;'
      return code
    },
    htmlCode() {
      let code = '&lt;body&gt;<br>'
      code    += '  &lt;div id="fanomena-form"/&gt;<br>'
      code    += '&lt;/body&gt;'
      return code
    },
    scriptCode() {
      let code = '&lt;script&gt;<br>'
      code    += `  fanomenaForms.loadForm("${this.slug}","fanomena-form")<br>`
      code    += '&lt;/script&gt;'
      return code
    }
  },
  async mounted() {
    this.$store.commit('SET_FOOTER_DISPLAY', false)
    let loaded = await this.loadScript()
    if (loaded) {
      this.setPreview()
      EventBus.$on('external_form_update', this.setPreview)
    }
  },
  onRouteEnters(to, from, next) {
    this.setPreview()
    next()
  },
  beforeDestroy() {
    this.$store.commit('SET_FOOTER_DISPLAY', true)
  },
  methods: {
    async loadScript() {
      try {
        await this.$loadScript(this.hileadzzPublicFormUrl.js)
        return true
      } catch(err) {
        console.log('Failed loading Leads Form script')
        return false
      }
    },
    setPreview() {
      // Only load preview if form JS is loaded
      if (typeof hileadzzPublicForms !== 'undefined') {
        if (this.hileadzzPublicFormUrl.apiOverwrite) {
          hileadzzPublicForms.loadFormPreview(this.structure, this.formId, this.hileadzzPublicFormUrl.apiOverwrite)
        } else {
          hileadzzPublicForms.loadFormPreview(this.structure, this.formId)
        }
      }
    },
    disableForm() {
      // disables the form so that no leads are created if the user fills it out
      let form              = document.getElementById('form-slug-form')
      let submitButton      = document.getElementById('form-submit')
      if (submitButton) {
        submitButton.disabled = true
      }
      if (form) {
        form.onsubmit = () => { return false }
      }
    }
  },
  watch: {
    item() {
      this.setPreview()
    }
  }
}
</script>
<style lang="sass">
.preview-right-box
  background: #F9FAFB
  padding: 20px 40px
  border-radius: 5px

  .preview-title
    margin-top: 0

  .preview-code
    color: $ink-lighter
    font-size: 13px

  pre
    white-space: pre-wrap
  @media(max-width: 575px)
    .preview-code
      overflow-wrap: break-word
    .preview-right-box
      margin-top: 20px

.hileadzz-external-form-app
  label
    min-height: 30px

  .input--select, .input--select-wrapper
    width: 99.7%

  .field--wrapper.input--select-wrapper
    height: 46px
    margin-bottom: 23px

  .input--select
    border: 2px solid #DFE2E8

  .input--select-wrapper:after
    top: 7px

  .btn
    background-color: #212736
    border: 1px solid #212736
    color: #F9FAFB
    border-radius: 0px
    padding: 0 25px 0 25px

</style>



// WEBPACK FOOTER //
// ExternalFormPreview.vue?f5fc7976